import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function departureSchedulesReducer(state = initialState.departureSchedules, action) {
	switch (action.type) {
		case types.LOAD_DEPARTURE_SCHEDULES_SUCCESS:
			return action.departureSchedules;
		case types.CREATE_DEPARTURE_SCHEDULE_SUCCESS:
			return [
				...state.filter(departureSchedule => departureSchedule.id !== action.departureSchedule.id),
				Object.assign({}, action.departureSchedule)
			];
		case types.UPDATE_DEPARTURE_SCHEDULE_SUCCESS:
			return [
				...state.filter(departureSchedule => departureSchedule.id !== action.departureSchedule.id),
				Object.assign({}, action.departureSchedule)
			];
		case types.DELETE_DEPARTURE_SCHEDULE_SUCCESS:
			return [
				...state.filter(departureSchedule => departureSchedule.id !== action.departureSchedule.id)
			];
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/departureSchedulesReducer.js